import { render, staticRenderFns } from "./medicalDiagnosis.vue?vue&type=template&id=d654776a&scoped=true"
import script from "./medicalDiagnosis.vue?vue&type=script&lang=js"
export * from "./medicalDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./medicalDiagnosis.vue?vue&type=style&index=0&id=d654776a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d654776a",
  null
  
)

export default component.exports